module.exports = __webpack_public_path__ + "static/media/sidebar.190285ce.jpg";